import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Campaign } from "../../models/campaign.model";
import { ApiUserService } from "../../services/user.service";
import { ToastUtils } from "../../helper/toast.helper";

export class RequestAccessController {
    public isDisabled = false;
    public activeCampaign: Campaign;

    private $window: any;
    private $cookies: any;
    private toast: ToastUtils;
    public __env: any;
    private apiUserService: ApiUserService;

    constructor(
        $window: any,
        $cookies: any,
        __env: any,
        ToastUtils: ToastUtils,
        ApiUserService: ApiUserService,
        CampaignDataProvider: CampaignDataProvider
    ) {
        this.$window = $window;
        this.$cookies = $cookies;
        this.toast = ToastUtils;
        this.__env = __env;
        this.apiUserService = ApiUserService;

        this.activeCampaign = CampaignDataProvider.getActiveCampaign();

        if (this.$cookies.get("noAccess") != "true") {
            this.$window.location = "/#/";
        }
    }

    sendRequest(): void {
        this.isDisabled = true;
        this.apiUserService.request_access({}).then((response: object) => {
            let json = response["data"];
            if (json.success) {
                this.toast.success(
                    "A request has been sent to access this campaign"
                );
            } else {
                this.isDisabled = false;
                this.toast.error();
            }
        });
    }

    requestSharedLicense(): void {
        this.isDisabled = true;
        this.apiUserService
            .requestSharedLicense({})
            .then((response: object) => {
                let json = response["data"];
                if (json.success) {
                    this.$cookies.put("noAccess", "false");
                    this.$window.location = "/#/";
                } else {
                    this.isDisabled = false;
                    this.toast.success(
                        "Unfortunately there is no shared license available to give you"
                    );
                }
            });
    }
}

angular
    .module("requestAccess", [])
    .controller("RequestAccessController", RequestAccessController);
